import React from "react";
import {
  ButtonIcon,
  IButtonIconProps,
  Icon,
  Typography
} from "fr-ito-web-react/react/esm";
import { joinClasses } from "ds-core/utils";

export enum ECButtonIconVariant {
  LIGHT = "light",
  DARK = "dark"
}

export const ICON_SIZES = {
  small: 16,
  medium: 24,
  large: 52
} as const;

export type ECButtonIconProps = {
  icon: string;
  variant?: ECButtonIconVariant;
  size?: "small" | "medium" | "large";
  label?: string;
  selected?: boolean;
  ariaLabel?: string;
  onClick?: (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => void;
} & Omit<IButtonIconProps, "icon" | "label">;

export const ECButtonIcon: React.FC<ECButtonIconProps> = (
  props: ECButtonIconProps
) => {
  const {
    icon = "account",
    variant = ECButtonIconVariant.DARK,
    size = "medium",
    label,
    designTokens,
    ariaLabel,
    className,
    ...remainingProps
  } = props;

  let targetDesignTokens = designTokens || {};
  const iconDesignTokens = {
    colorToken:
      variant === "dark" ? "ito-primary-icon-color" : "ito-neutral-icon-color"
  };
  const labelDesignTokens = {
    colorToken:
      variant === "dark" ? "ito-primary-text-color" : "ito-neutral-text-color"
  };
  targetDesignTokens = {
    ...targetDesignTokens,
    borderRadiusToken: "",
    borderWidthToken: "ito-border-width-0",
    borderColorToken: "ito-gray200-border",
    hoverBorderColorToken: "hover-ito-gray100-border"
  };

  return (
    <ButtonIcon
      className={joinClasses(`ec-button-icon-${size}`, className)}
      designTokens={targetDesignTokens}
      size={size}
      icon={
        <Icon
          designTokens={iconDesignTokens}
          name={icon}
          size={ICON_SIZES[size]}
        />
      }
      label={
        <Typography designTokens={labelDesignTokens} textAlign="center">
          {label}
        </Typography>
      }
      aria-label={ariaLabel}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...remainingProps}
    />
  );
};

ECButtonIcon.displayName = "ECButtonIcon";
